// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__8N0C7","col":"styles_col__3mYK5","actions":"styles_actions__3B3yZ","conflict":"styles_conflict__26JJt"};